import { styled } from "@mui/system";
export const StyledAccordionWrapper = styled("div")(({ theme }) => ({
  "& .MuiAccordion-root": {
    borderTop: "1px solid #E6E6E6",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    }
  },
  "& .MuiAccordionSummary-root": {
    display: "flex",
    width: "100%",
    marginBottom: -1,
    minHeight: "56px!important",
    padding: 0,
    "&.Mui-expanded": {
      marginTop: "0px !important",
      marginBottom: "0px !important",
      fontWeight: 500,
      "& .activePanel": {
        display: "inline-block",
        width: "4px",
        height: "16px",
        backgroundColor: "#8D0C10",
        borderRadius: "2px"
      },
      "& .accordionTitle": {
        fontWeight: 500
      }
    }
  },
  "& .MuiAccordionSummary-content": {
    margin: 0,
    "& .accordionTitle": {
      letterSpacing: "0px",
      "& .title": {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#8D0C10",
        margin: 0
      },
      "& .subTitle": {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "28px",
        color: "#757575",
        margin: 0
      },
      "& .helperIcon": {
        width: "20px",
        height: "20px",
        fontSize: "1.25rem",
        color: "#525252",
        fontWeight: "400"
      },
      "& .expandedDescription": {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "18px",
        color: "#757575",
        margin: 0,
        [theme.breakpoints.up("sm")]: {
          fontSize: "16px",
          lineHeight: "24px"
        }
      }
    }
  },
  "& .MuiAccordionDetails-root": {
    flexDirection: "column",
    padding: 0,
    marginBottom: "24px"
  },
  "& .accordionSummaryWrapper": {
    display: "flex",
    width: "100%"
  },
  "& .customAccordionSummaryWrapper": {
    justifyContent: "space-between",
    alignItems: "center"
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    fill: "#BF0000",
    width: "20px",
    height: "10px",
    color: "#BF0000",
    "& svg": {
      fill: "#BF0000"
    }
  },
  "& .success": {
    height: "24px",
    width: "24px",
    marginRight: "8px"
  }
}));
